import { render, staticRenderFns } from "./CountOccurenceTable.vue?vue&type=template&id=06c68a19&scoped=true&"
import script from "./CountOccurenceTable.vue?vue&type=script&lang=js&"
export * from "./CountOccurenceTable.vue?vue&type=script&lang=js&"
import style0 from "./CountOccurenceTable.vue?vue&type=style&index=0&id=06c68a19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c68a19",
  null
  
)

export default component.exports